import RootState from 'ducks/RootState';
import orderBy from 'lodash/orderBy';

export const getAccesses = (state: RootState) => state.accesses;

export const getBulkAccessErrorFiles = (state: RootState) =>
  orderBy(getAccesses(state).errorFiles, ['createdAt'], ['desc']);

export const getIsFetching = (state: RootState) => getAccesses(state).isFetching;

export const getIsFetchingErrorFiles = (state: RootState) => getAccesses(state).isFetchingErrorFiles;
